<template>
  <div class="game-input-on-background-wrapper">
    <!-- :style="'background-image: url('+backgroundImageUrl+');'"> -->
    <div class="inner-game-conteiner">
      <div class="element-row" v-for="(item, index) in startGameConfig.items" :key="item.id">
        <div class="prefix-text">{{ item.comparableElements[0] }}</div>
        <tr-input
          :config="item"
          :tr-input-value="inputData[index]"
          :input-width="startGameConfig.inputWidth"
          :input-height="startGameConfig.inputHeight"
          :input-font-size="startGameConfig.inputFontSize"
          :max-length="2"
        ></tr-input>
        <div class="postfix-text">{{ item.comparableElements[1] }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import TrInput from '../TrInput/TrInputV2';
import defaultMixin from '../../mixins/defaultMixinV2';
export default {
  name: 'tr-input-on-background-geo-demo5-v2',
  components: {
    TrInput,
  },
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  mixins: [defaultMixin],
  data() {
    return {
      inputData: [],
    };
  },
  beforeMount() {
    this.gameInit();
    // console.log('  this.longestWordLength', this.longestWordLength.correct, this.longestWordLength.correct.length);
    // console.log('this.inputData', this.inputData);
  },
  mounted() {},
  methods: {
    gameInit() {
      this.startGameConfig.items = this.prepareData();
      this.inputData = _.map(this.startGameConfig.items, (item) => {
        return { correct: item.correct, val: '', block: false, inputStatus: null };
      });
      this.longestWordLength = _.maxBy(this.inputData, (item) => {
        return item.correct.length;
      });
    },
    prepareData() {
      this.startGameConfig.items = this.startGameConfig.shuffle
        ? _.shuffle(this.startGameConfig.items)
        : this.startGameConfig.items;
      let data = _.map(this.startGameConfig.items, (item) => {
        if (item.comparableElements) {
          item.comparableElements = item.shuffle ? _.shuffle(item.comparableElements) : item.comparableElements;
          item.correct = this.setEquivalence(item.comparableElements[0], item.comparableElements[1]);
        }
        return item;
      });
      return data;
    },
    setEquivalence(elem1, elem2) {
      let array1 = this.getNumberFromString(elem1);
      let array2 = this.getNumberFromString(elem2);
      if (array1[0] / array1[1] === array2[0] / array2[1]) {
        return '=';
      } else if (array1[0] / array1[1] < array2[0] / array2[1]) {
        return '<';
      } else if (array1[0] / array1[1] > array2[0] / array2[1]) {
        return '>';
      }
      return 'error';
    },
    getNumberFromString(string, marker = ':') {
      let stringWithoutSpace = string.replace(/\s/g, '');
      let array = stringWithoutSpace.split(marker);
      if (array.length === 2) {
        return _.map(array, (elem) => {
          return parseInt(elem);
        });
      }
      return false;
    },
    /**
     * reset all containerEnd without reset reactivity
     * @method resetGameAction
     */
    resetGameAction() {
      _.each(this.inputData, (item, key, collection) => {
        item.val = '';
        item.block = false;
        item.inputStatus = null;
      });
      this.gameInit();
      // this.questionsList = this.processQuestionsList();
    },
    checkGameAction() {
      let status = _.reduce(
        this.inputData,
        (result, value, key) => {
          let temVal = null;
          let index = _.findIndex(value.correct, (o) => {
            return o === _.trim(value.val.toLowerCase());
          });
          if (index != -1) {
            temVal = result && true;
            value.val = _.trim(value.val.toLowerCase());
            value.block = true;
            value.inputStatus = 'correct';
          } else {
            temVal = false;
            value.val = '';
            value.block = true;
            value.inputStatus = 'incorrect';
            setTimeout(() => {
              value.val = '';
              value.block = false;
              value.inputStatus = null;
            }, 1000);
          }
          return temVal;
        },
        true
      );
      console.log('ANSWER: ', status);
      if (!status) {
        _.each(this.inputData, (item, key) => {
          console.log('item', item);
        });
      }
      return status;
    },
  },
  computed: {
    maxCharNumber() {
      return _.round((this.longestWordLength.correct.length * 120) / 100).toString();
    },
    backgroundImageUrl() {
      return 'static/' + this.startGameConfig.background;
    },
  },
};
</script>

<style lang="scss" scoped>
.game-input-on-background-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  // background-image: url("~@/assets/icons/przybornik_kosz.png");
  .inner-game-conteiner {
    // position: relative;
    // top: 100px;
    // left: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    .element-row {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: row;
      width: 80%;
      .prefix-text {
        width: 35%;
        display: flex;
        margin-right: 2%;
        justify-content: flex-end;
      }
      .postfix-text {
        width: 35%;
        display: flex;
        margin-left: 2%;
        justify-content: flex-start;
      }
    }
  }
}
</style>
